import React, { useMemo, useState } from "react";
import { useLang } from "../i18n/LanguageContext";
import { useContent } from "../lib/useContent";
import { useSeo } from "../components/common";
import { PageHero } from "../components/PageHero";
import { SectionHead, BeforeAfter, CTABand } from "../components/blocks";
import { ProjectCard } from "../components/cards";
import { IMG } from "../data/site";

export default function Projects() {
  const { t } = useLang();
  useSeo("Projects | Sparko Cleaning Netherlands", "Explore Sparko's featured cleaning projects across offices, hotels, warehouses and retail in the Netherlands.");
  const { data: projects } = useContent("projects");
  const [cat, setCat] = useState("all");
  const cats = useMemo(() => ["all", ...new Set(projects.map((p) => p.category))], [projects]);
  const shown = cat === "all" ? projects : projects.filter((p) => p.category === cat);

  return (
    <div>
      <PageHero title="Our Projects" crumb={t.nav.projects} bg={IMG.pressure}
        sub="Real results for real clients — a selection of the spaces Sparko keeps immaculate." />

      <section className="mx-auto max-w-7xl px-5 md:px-8 py-16">
        <div className="flex flex-wrap gap-2 justify-center mb-12" data-testid="project-filters">
          {cats.map((c) => (
            <button key={c} onClick={() => setCat(c)} data-testid={`pfilter-${c}`}
              className={`rounded-full px-4 py-2 text-sm font-medium capitalize transition-colors ${cat === c ? "bg-navy text-white" : "bg-muted text-navy hover:bg-blue/10"}`}
              style={cat !== c ? { background: "var(--muted)" } : {}}>{c}</button>
          ))}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {shown.map((p, i) => <ProjectCard key={p.id} p={p} index={i} />)}
        </div>
      </section>

      <section className="bg-navy py-24 grain">
        <div className="mx-auto max-w-6xl px-5 md:px-8 grid md:grid-cols-2 gap-12 items-center">
          <div>
            <SectionHead light eyebrow={t.sections.beforeAfter} title={t.sections.beforeAfter} sub={t.sections.beforeAfterSub} />
          </div>
          <BeforeAfter className="aspect-[4/3] shadow-2xl" />
        </div>
      </section>

      <CTABand />
    </div>
  );
}
